import { RecoilState, useResetRecoilState } from 'recoil'

export function useRecoilClear(state: Record<string, RecoilState<any>>) {
    const resetters = Object.keys(state).map((key) =>
        // biome-ignore lint/correctness/useHookAtTopLevel: <explanation>
        useResetRecoilState(state[key]),
    )

    function reset() {
        // biome-ignore lint/suspicious/useIterableCallbackReturn: <explanation>
        resetters.forEach((reset) => reset())
    }

    return reset
}
